import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

const fetchMe = (): AxiosPromise<Me> => {
  return api.get<Me>(endpoints.ADMIN_AUTH.ME);
};

const login = (request: { email: string; password: string }): AxiosPromise<AuthResponse> => {
  return api.post<AuthResponse>(endpoints.ADMIN_AUTH.LOGIN, request);
};

// const preRegister = (request: { email: string; password: string; confirmPassword: string }): AxiosPromise<number> => {
//   return api.post<number>(endpoints.AUTH.PREREGISTER, request);
// };

// const register = (request: RegisterFormValues): AxiosPromise<AuthResponse> => {
//   return api.post<AuthResponse>(endpoints.AUTH.REGISTER, request);
// };
export const adminAuthApi = {
  fetchMe,
  login,
  // preRegister,
  // register,
};

export interface Me {
  userId: number;
  email: string;
  firstName: string;
  surname: string;
  phone?: string;
  pesel?: string;
  bornPlace?: string;
  licencePhoto?: string;
  bornDate?: Date;
}
export interface AuthResponse {
  token: string;
  user: Me;
}
